import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from '../../../util/withRouter';
import _ from 'lodash';
import { Button } from 'react-bootstrap';

import FormattedMessage from '../../../components/FormattedMessage';
import Loading from '../../../components/Loading/Loading';

import { getDigitalPlans, updateStepData, error } from '../AddonActions';

import { PAGES, trackPageView } from '../../../util/mixpanel';
import { getLocalePrice } from '../../../util/billingUtils';

import '../Addon.scss';

export class DigitalPlans extends Component {
  static defaultProps = {
    model: {},
    onNext: function() {}
  };

  constructor(props) {
    super(props);
    this.state = {
      planId: '',
      isAnnual: props.isAnnual,
      annualSubscription: true
    };

    this.handleNext = this.handleNext.bind(this);
    this.selectPlan = this.selectPlan.bind(this);
  }

  componentDidMount() {
    this.props.getDigitalPlans();

    if (this.props.model.planId) {
      this.setState({
        planId: this.props.model.planId,
        annualSubscription: this.props.model.planId.indexOf('annual') > -1,        
      });
    } else if (!this.props.isUpgrade && this.props.addons.monthly) {
      this.selectRecommendedPlan();
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (!_.isEqual(prevProps.addons, this.props.addons)) {
      this.selectRecommendedPlan();
    }

    if (prevProps.model.planId != this.props.model.planId && !!this.props.model.planId) {
      this.setState({
        planId: this.props.model.planId,
        annualSubscription: this.props.model.planId.indexOf('annual') > -1,
        //isAnnual: this.props.model.currentPlan && this.props.model.currentPlan.indexOf('annual') > -1
      });
    }
  }

  selectRecommendedPlan() {
    const addons = this.state.isAnnual ? this.props.addons.annual : this.props.addons.monthly;    
  }

  handleNext() {
    if (this.props.model.currentAddon === this.props.model.planId) {
      return false;
    }

    this.props.onNext(2);
  }

  selectPlan(plan) {
    const model = {
      ...this.props.model,
      planId: plan.id,
      planName: plan.name,
      planType: plan.periodUnit,
      allowed: plan.allowed
    };
    this.props.updateStepData(model);
  }

  trackContactUsOpenEvent(){
    trackPageView(PAGES.CONTACT_US);
  }

  render() {
    const { addons, model } = this.props;
    const { planId, isAnnual } = this.state;
    const currentAddon = isAnnual && _(addons.annual).find(a=>a.id === model.currentAddon) ||
                         !isAnnual && _(addons.monthly).find(a=>a.id === model.currentAddon);
    let allowedSeats = 0;
    if (currentAddon){
      allowedSeats = currentAddon.allowed;
    }
    if (!addons.annual) {
      return <div className='table-loading loader-delay'><Loading /></div>;
    }

    const renderPlan = (p, isAnnual) => {
      return (
        <div key={p.id} className={`${planId == p.id ? 'active' : ''}`}>
          <div className='plan-name'>
            <div className='plan-image'>
              <div className={p.name.toString().toLowerCase().split(" ").join('-')}></div>
            </div>
            <h3>{p.name}</h3>
          </div>
          <div className='line'></div>
          <div className='plan-boards'>
            {p.allowed}{' '}              
            <FormattedMessage id={`seat`} mode="capitalize" plural="true" />  
          </div>
          <div className='line'></div>
          <div className='plan-price'>
            <p className='price'>
              {getLocalePrice(p, isAnnual ? Math.round(p.priceTotal / 12) : p.priceTotal, true)}
              <small> / month</small>
            </p>
            <p>
              {getLocalePrice(p, isAnnual ? p.priceTotal : p.priceTotal * 12, true)}
              <small> / year</small>
            </p>
          </div>
          <div className='line'></div>
          {/*<div className='plan-premium-package'>
            <Switch
              id="premiumPackage"
              className="switch_box_right_label"
              name="premiumPackage"
              label={['Premium Package', <br/> ,'(+$228 / year)']}
            />
          </div>*/}
          {model.currentAddon ? (
            <Button
              onClick={() => this.selectPlan(p)}
              className='btn btn-select'
              disabled={p.id === model.currentAddon}
            >
              {p.id === model.currentAddon ? 'Current plan' : p.allowed < allowedSeats ? 'Downgrade' : 'Upgrade'}
            </Button>
          ) : (
            <Button onClick={() => this.selectPlan(p)} className='btn btn-select'>
              {planId == p.id ? 'Selected' : 'Select'} plan
            </Button>
          )}
        </div>
      );
    };

    return (
      <div>
        <div className='subscribe_inner_content'>
          <div className='subscribe_plan'>
            <div className='chose_subscription'>
              <p className='subscription'>&nbsp;</p>
            </div>
            
            {!this.state.annualSubscription ? (
              <div className='plans-list'>{addons.monthly.map(p => renderPlan(p))}</div>
            ) : (
              <div className='plans-list'>{addons.annual.map(p => renderPlan(p, true))}</div>
            )}
          </div>

          <div className='action_box_billing'>
            {!this.props.expired ? (
              <Button variant='secondary' className='btn_prev' onClick={this.props.router.goBack}>
                Back
              </Button>
            ) : (
              <div></div>
            )}
            <p className='node'>
              <span>*Your order may be subject to VAT at the rate applicable in your country.</span>
              <span>
                *Need more than 10 <FormattedMessage id={`seat`} mode="capitalize" plural="true" />?{' '}
                <a href="https://getnave.com/contact" 
                  onClick={this.trackContactUsOpenEvent}
                  onAuxClick={this.trackContactUsOpenEvent}
                  target="_blank">
                  Contact us
                </a>{' '}
                for a custom quote!
              </span>
            </p>
            <Button variant='primary' className='btn_next' onClick={this.handleNext}>
              Next
            </Button>
          </div>
        </div>
      </div>
    );
  }
}

const mapDispatchToProps = dispatch => {
  return {
    getDigitalPlans: () => dispatch(getDigitalPlans()),
    updateStepData: model => dispatch(updateStepData(model)),
    setError: err => dispatch(error(err, { log: false }))
  };
};

const mapStateToProps = state => {
  
  return {
    app: state.app.app,
    addons: state.digital.addons,
    model: state.digital.model,
    expired: state.auth.user.expired,
    username: state.auth.user.profile.name,
    email: state.auth.user.email
  };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(DigitalPlans));
